import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { LoggingService } from '@services/logging.service';
import { FilterService } from '@services/filter.service';
import { NgModel } from '@angular/forms';
import { RegularExpressionPattern } from '@shared/_constants';
import * as Constants from '@shared/_constants';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FilterUtilService } from '../shared/filter-util.service';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
  selector: 'app-filter-shareholder-characteristics',
  templateUrl: './filter-shareholder-characteristics.component.html',
  styleUrls: ['./filter-shareholder-characteristics.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  encapsulation: ViewEncapsulation.None,
})
export class FilterShareholderCharacteristicsComponent implements OnInit {
  public shareholderCharacteristics: TreeNode[];
  @Input() filter: any;
  @Input() submitClicked: boolean;
  @Input() readOnly = false;

  formDirty = false;
  regularExpressionPattern: typeof RegularExpressionPattern = RegularExpressionPattern;

  private destroy$ = new Subject();

  constructor(private logger: LoggingService, private filterService: FilterService, private filterUtilService: FilterUtilService) {}

  ngOnInit() {
    this.loadInitialData();
  }

  loadInitialData() {
    this.logger.info(this.constructor.name, Constants.LoggerMessages.LOGGER_NGONINIT, Constants.LoggerMessages.LOGGER_START);
    this.filterUtilService.spinnerRS.next(true);
    this.filterService
      .getShareholderCharacteristics$(this.readOnly)
      .pipe(takeUntil(this.destroy$))
      .subscribe((_shareholderCharacteristics) => {
        this.shareholderCharacteristics = _shareholderCharacteristics;
        this.filterUtilService.spinnerRS.next(false);
      });
  }

  ShowValidationMessage(item: NgModel): boolean {
    return (item.errors || false) && (this.submitClicked || !item.pristine || item.touched);
  }

  public sortSelection(selection: TreeNode[]): void {
    return this.filterUtilService.sortSelection(selection);
  }
}
